import React from "react";

/**
 * Panel icon similar to Claude/ChatGPT sidebar toggle.
 * When sidebar is open: icon suggests "collapse to left"
 * When sidebar is closed: icon suggests "expand from left"
 */
const SidebarPanelIcon = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Outer frame */}
    <rect x="3" y="3" width="18" height="18" rx="2" />
    {/* Sidebar divider line */}
    <line x1="9" y1="3" x2="9" y2="21" />
  </svg>
);

/**
 * Toggle button inside the sidebar header — collapses the sidebar.
 */
export const SidebarCollapseButton = ({ onClick }) => (
  <button
    className="sidebar-toggle-btn"
    onClick={onClick}
    aria-label="Dölj sidofält"
    title="Dölj sidofält"
  >
    <SidebarPanelIcon />
  </button>
);

/**
 * Floating button shown when sidebar is collapsed — opens the sidebar.
 * Positioned at top-left of the content area, like Claude/ChatGPT.
 */
export const SidebarOpenButton = ({ onClick }) => (
  <button
    className="sidebar-open-btn"
    onClick={onClick}
    aria-label="Visa sidofält"
    title="Visa sidofält"
  >
    <SidebarPanelIcon />
  </button>
);
